/* eslint-disable react/prop-types */
import { motion } from "framer-motion"
import { navigate } from "gatsby"
import React, { useEffect, useState } from "react"
import { useQuery } from "@apollo/client"
import client from "../../apollo/client"
import { BEACON_OPEN, SIDEBAR_OPEN } from "../../apollo/queries"
import VERSION from "../../version"
import Icons from "../Icon/icon"
import { PropTypes } from "prop-types"

const SidebarNavItem = ({
  variant,
  text,
  route,
  icon,
  fa,
  onClickOverride,
  close,
}) => {
  const activeStyle =
    route && window.location.pathname.includes(route)
      ? { background: "rgba(0, 0, 0, .25)" }
      : {}

  const handleNavigation = () => {
    if (typeof close === "function" && window.innerWidth < 800) close()
    if (route !== "support") navigate(`/a/${route}`)
  }

  return (
    <motion.div
      variants={variant}
      onClick={onClickOverride || handleNavigation}
      style={activeStyle}
      className="flex items-center mb-2 pl-8 pr-4 pt-3 ms:pt-4 pb-3 ms:pb-4 text-white"
    >
      <span className="mr-3 ml-3 text-xl">
        <Icons icon={icon} fa={fa} />
      </span>{" "}
      <span className="font-bold cursor-pointer text-base">{text}</span>
    </motion.div>
  )
}

const SidebarNavItems = ({ close }) => {
  const {
    data: { beaconOpen },
  } = useQuery(BEACON_OPEN)

  const [beaconHandler, setBeaconHandler] = useState(false)
  const [beaconOpened, setBeaconOpen] = useState(beaconOpen)

  useEffect(() => {
    // Linking beaconOpen state to local state when closeBeacon button was triggered
    setBeaconOpen(beaconOpen)
    setBeaconHandler(beaconOpen)
    console.log("LOG: [Sidebar] -> Hook beacon set beacon to:", beaconOpen)
  }, [beaconOpen])

  const toggleBeacon = setValue => {
    const value = typeof setValue === "boolean" ? setValue : !beaconOpened
    setBeaconOpen(value)
    client.writeData({ data: { beaconOpen: value } })
    console.log("LOG: [Sidebar] -> toggleBeacon set beacon to:", value)
  }

  const toggleSupport = () => {
    toggleBeacon()
    setBeaconHandler(!beaconHandler)
    window.Beacon(!beaconHandler ? "open" : "close")
    if (!beaconHandler) close()
  }

  const list = {
    visible: {
      opacity: 1,
      transition: {
        when: "beforeChildren",
        staggerChildren: 0.05,
      },
    },
    hidden: {
      opacity: 0,
      transition: {
        when: "afterChildren",
      },
    },
  }

  const item = {
    visible: {
      opacity: 1,
      x: 0,
    },
    hidden: { opacity: 0, x: -100 },
  }

  return (
    <motion.div
      id="com-nav-items"
      className=""
      initial="hidden"
      animate="visible"
      // variants={list}
    >
      <SidebarNavItem
        // variant={item}
        text="Journal"
        route="journal"
        icon="class"
        fa="feather-alt"
        close={close}
      />
      <SidebarNavItem
        // variant={item}
        text="Guides"
        route="guides"
        icon="photo_album"
        close={close}
      />
      <SidebarNavItem
        // variant={item}
        text="Analytics"
        route="insights"
        icon="analytics"
        close={close}
      />
      <SidebarNavItem
        // variant={item}
        text="Settings"
        route="settings"
        icon="settings"
        close={close}
      />
      <SidebarNavItem
        // variant={item}
        text="Support"
        route="support"
        icon="comment"
        onClickOverride={toggleSupport}
        close={close}
      />
      <SidebarNavItem
        // variant={item}
        text="Logout"
        route="logout"
        icon="logout"
        close={close}
      />
    </motion.div>
  )
}

const Sidebar = React.memo(({ toggle }) => {
  const renderAnimationDelayMS = 50
  const showContentDelayMS = 100

  const {
    data: { sidebarOpen: isOpen },
  } = useQuery(SIDEBAR_OPEN)

  const open = "w-sidebar-open sidebar-slide-in"
  const closed = "w-sidebar-closed sidebar-slide-out overflow-hidden"
  const [className, setClassName] = useState(isOpen ? open : closed)
  const [showContent, setShowContent] = useState(isOpen)

  if (isOpen && !className.includes("open")) {
    setTimeout(() => {
      setClassName(open)
      setTimeout(() => {
        setShowContent(true)
      }, showContentDelayMS)
    }, renderAnimationDelayMS)
  }

  if (!isOpen && !className.includes("closed")) {
    setClassName(closed)
    setShowContent(false)
  }

  return (
    <React.Fragment>
      <div
        id="com-sidebar"
        className={`min-h-450 transition-all duration-200 ease-in-out self-stretch ${className}`}
      >
        {showContent && (
          <React.Fragment>
            <div className="mt-10 mb-10 sm:mt-20 sm:mb-20 text-center text-white uppercase text-lg font-bold tracking-3.5">
              Reflection.app
              <div
                id="app-version-number"
                className="text-xs py-2 pl-12 sm:pl-8 text-left"
              >
                {VERSION.number}
              </div>
            </div>
            <SidebarNavItems close={toggle} />
            <motion.img
              className="fixed bottom-20 sm:bottom-25 left-50 sidebar-logo"
              src="/app/assets/img/holstee-logo.png"
              alt="Holstee"
            />
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  )
})

export default Sidebar

export const SidebarDimmer = ({ open, toggle }) => {
  return open ? (
    <motion.div
      initial={{
        backgroundColor: "rgba(0, 0, 0, .1)",
      }}
      animate={{
        backgroundColor: "rgba(0, 0, 0, .75)",
        transition: { duration: 0.5 },
      }}
      onClick={toggle}
      id="dimmed-bg"
      className="fixed h-full w-full  z-0 top-0 right-0 bottom-0 left-0 sm:visible lg:hidden"
    ></motion.div>
  ) : null
}

SidebarDimmer.propTypes = {
  open: PropTypes.bool,
  toggle: PropTypes.func,
}
